import { Reveal } from "../components/Reveal";
import { usePageMeta } from "../hooks/usePageMeta";

export const PageShell = ({ overline, title, lede, children, testId, metaTitle }) => {
    usePageMeta(
        metaTitle || (title ? `${title.replace(/<[^>]*>/g, "")} — Titan Haven Group LLC` : undefined),
        lede,
    );
    return (
    <main data-testid={testId}>
        <section className="border-b border-thg-border">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 md:py-32">
                <Reveal>
                    <p className="text-xs tracking-[0.25em] uppercase font-bold text-thg-tertiary">{overline}</p>
                </Reveal>
                <Reveal delay={0.1}>
                    <h1 className="mt-5 font-display text-4xl md:text-5xl lg:text-6xl tracking-tight leading-tight font-medium text-white max-w-3xl">
                        {title}
                    </h1>
                </Reveal>
                {lede && (
                    <Reveal delay={0.2}>
                        <p className="mt-6 text-base md:text-lg leading-relaxed text-thg-secondary max-w-2xl">{lede}</p>
                    </Reveal>
                )}
            </div>
        </section>
        {children}
    </main>
    );
};

export const ShellSection = ({ children, className = "" }) => (
    <section className={`py-16 md:py-24 border-b border-thg-border last:border-b-0 ${className}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">{children}</div>
    </section>
);
